import { render, staticRenderFns } from "./LastLogs.vue?vue&type=template&id=73ffd0db&scoped=true&"
import script from "./LastLogs.vue?vue&type=script&lang=js&"
export * from "./LastLogs.vue?vue&type=script&lang=js&"
import style0 from "./LastLogs.vue?vue&type=style&index=0&id=73ffd0db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ffd0db",
  null
  
)

export default component.exports